import ContentsToReact from '@/components/ContentsToReact/ContentsToReact';
import GenericModals from '@/components/GenericModals/GenericModals';
import Page from '@/components/Page/Page';
import { extractContents } from '@/helpers/extractContents';
import extractPageMetaFromRouteData from '@/helpers/extractPageMetaFromRouteData';
import { useInitialPageDataLayer } from '@/hooks/useInitialPageDataLayer/useInitialPageDataLayer';
import { PageModalModel } from '@/models/page';
import BackToTopButton from '@uikit/components/BackToTopButton/BackToTopButton';
import EnercityGwkFooter from '@uikit/components/EnercityGwkFooter/EnercityGwkFooter';
import Layout from '@uikit/components/Layout/Layout';
import PromoBanner from '@uikit/components/PromoBanner/PromoBanner';
import usePromoBanner from '@uikit/components/PromoBanner/usePromoBanner';
import { CmsComponentsContext } from '../CmsComponentsContext';
import cmsComponents from './CoursesMainPage.cmsComponents';
import type { CoursesMainPageProps } from './types';

const CoursesMainPage = (pageData: PageModalModel<CoursesMainPageProps>) => {
  const meta = extractPageMetaFromRouteData(pageData);

  const { isBannerHidden } = usePromoBanner(pageData.props.promoBanner);

  const {
    extractedContents: [noticeBarArea],
    restContents,
  } = extractContents(['notice-bar-area'], pageData.contents);

  useInitialPageDataLayer();

  return (
    <CmsComponentsContext.Provider value={cmsComponents}>
      {noticeBarArea && <ContentsToReact contents={noticeBarArea} />}

      <Layout background={pageData.props.background}>
        <Page meta={meta}>
          {restContents && <ContentsToReact contents={restContents} />}
        </Page>

        <BackToTopButton
          isFixed={
            pageData.props.promoBannerVisible === 'promoBanner' &&
            !isBannerHidden
          }
        />

        <EnercityGwkFooter />
      </Layout>

      <GenericModals modals={pageData.modals} />

      {pageData.props.promoBannerVisible === 'promoBanner' &&
        pageData.props.promoBanner && (
          <PromoBanner banner={pageData.props.promoBanner} />
        )}
    </CmsComponentsContext.Provider>
  );
};

export default CoursesMainPage;
